/* eslint-disable react/jsx-props-no-spreading */

import PropTypes from "prop-types";
import React from "react";

const RichTypography = React.forwardRef(function RichTypography(
  { children, component, ...props },
  ref
) {

  if (!children) {
    return null;
  }
  if (typeof children === "string") {
    return (
      <div
        // We default to `div` to allow other block elements like <p> to be used inside
        // `children`
        component={component}
        dangerouslySetInnerHTML={{
          __html: children,
        }}
        {...props}
        ref={ref}
      />
    );
  }
  return (
    <div component={component} {...props} ref={ref}>
      {children}
    </div>
  );
});

RichTypography.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType,
};

RichTypography.defaultProps = {
  children: null,
  component: "div",
};

export default RichTypography;